import { render, staticRenderFns } from "./ResultGuide.vue?vue&type=template&id=30b498b0&scoped=true&lang=pug&"
import script from "./ResultGuide.vue?vue&type=script&lang=ts&"
export * from "./ResultGuide.vue?vue&type=script&lang=ts&"
import style0 from "./ResultGuide.vue?vue&type=style&index=0&id=30b498b0&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30b498b0",
  null
  
)

export default component.exports